<template>
    <aside class="sidebar collapsed no-selection no-drag p-0 ps-3 m-0" style="min-width: 100px; height: 100vh;">
      <header class="sidebar-header pe-3">
         <a href="" class="header-logo">
            <img src="@/assets/img/logo-sm.png" alt="">
         </a>
         <button class="togller me-1">
            <img src="@/assets/img/chevron_left.png" id="icon" class="material-symbols-rounded">
         </button>
      </header>
      <nav class="sidebar-nav">
         <!-- Primary Navigation -->
        <ul class="nav-list primary-nav m-0">
         <li class="nav-item">
            <span class="nav-tooltip">{{ dictionary["Dashboard"][session.user.language] }}</span>
            <a href="" class="nav-link" @click.prevent="ToDash">
              <img src="@/assets/img/home.png" id="icon" class="material-symbols-rounded">
                <span class="nav-label">Dashboard</span>
            </a>
             
         </li>
         <li class="nav-item">
            <span class="nav-tooltip">{{ dictionary["Utillajes"][session.user.language] }}</span>
            <a href="" class="nav-link" @click.prevent="ToUtillajes">
              <img src="@/assets/img/construction.png" id="icon" class="material-symbols-rounded">
                <span class="nav-label">{{ dictionary["Utillajes"][session.user.language] }}</span>
            </a>
             
         </li>
 
         <li class="nav-item">
            <span class="nav-tooltip">{{ dictionary["Amarres"][session.user.language] }}</span>
            <a href="" class="nav-link" @click.prevent="ToDevices">
              <img src="@/assets/img/Precision_Manufacturing.png" id="icon" class="material-symbols-rounded">
                <span class="nav-label">{{ dictionary["Amarres"][session.user.language] }}</span>
            </a> 
         </li>
 
         <li class="nav-item">
            <span class="nav-tooltip">{{ dictionary["Gráficas"][session.user.language] }}</span>
            <a href="" class="nav-link" @click.prevent="ToCharts">
              <img src="@/assets/img/insert_chart.png" id="icon" class="material-symbols-rounded">
                <span class="nav-label">{{ dictionary["Gráficas"][session.user.language] }}</span>
            </a>
         </li>

         <li class="nav-item dropdown-container" v-if="isMantenimiento">
            <a class="nav-link dropdown-toggler">
              <img src="@/assets/img/settings.png" id="icon" class="material-symbols-rounded">
              <span class="nav-label">{{ dictionary["Configuración"][session.user.language] }}</span>
              <img src="@/assets/img/keyboard_arrow_down.png" id="icon" class="dropdown-icon material-symbols-rounded">
            </a> 
            <ul class="dropdown-menu">
              <li class="nav-item">
                <a href="" class="nav-link dropdown-link" @click="ToMachines">{{ dictionary["Utillajes"][session.user.language] }}</a>
              </li>
              <li class="nav-item">
                <a href="" class="nav-link dropdown-link" @click="ToDevicesConf">{{ dictionary["Amarres"][session.user.language] }}</a>
              </li>
              <li class="nav-item" v-if="isFabricante">
                <a href="" class="nav-link dropdown-link" @click.prevent="ToUsers">{{ dictionary["Usuarios"][session.user.language] }}</a>
              </li>
            </ul>
          </li>

          <li class="nav-item">
            <span class="nav-tooltip">{{ dictionary["Logs"][session.user.language] }}</span>
            <a href="" class="nav-link" @click.prevent="ToLogs">
              <img src="@/assets/img/system_logs.png" id="icon" class="material-symbols-rounded">
                <span class="nav-label">{{ dictionary["Logs"][session.user.language] }}</span>
            </a>
          </li>
        </ul>
 
        <!-- Secondary Navigation -->
        <ul class="nav-list secondary-nav m-0">
          <li class="nav-item">
            <a  class="nav-link" @click.prevent="ToProfile">
              <img src="@/assets/img/account_circle.png" id="icon" class="material-symbols-rounded">
              <span class="nav-label">{{ dictionary["Mi perfil"][session.user.language] }}</span>
            </a>
            <span class="nav-tooltip">{{ dictionary["Mi perfil"][session.user.language] }}</span>
          </li>
          <li class="nav-item">
            <a  class="nav-link" @click="logOutRequest" >
              <img src="@/assets/img/logout.png" id="icon" class="material-symbols-rounded">
              <span class="nav-label">{{ dictionary["Cerrar sesión"][session.user.language] }}</span>
            </a>
            <span class="nav-tooltip">{{ dictionary["Cerrar sesión"][session.user.language] }}</span>
          </li> 
          <span class="tx-white tx-14 text-center m-0 mt-auto p-0 pe-3 w-100" style="position: relative; left: -5px;">{{ this.$version }}</span>
          <span class="tx-white tx-14 text-center m-0 mt-auto p-0 pe-3 w-100" style="position: relative; left: -5px;">{{ clock }}</span>
        </ul>

      </nav>
    </aside>
 </template>
 
 <script>
import api from '@/services/api';

export default {
  name: "SideMenuPrincipal",
  emits: ["toggleSideMenu", "logOutRequest"],
  props: {
    session: {
      type: Object,
      required: true
    },
    dictionary: {
      type: Object,
      required: true
    },
    visibility: {
      type: Object,
      required: true
    },
    availableModules: {
      type: Object,
      required: true
    },
    isOperario: {
      type: Boolean,
      required: true
    },
    isMantenimiento: {
      type: Boolean,
      required: true
    },
    isFabricante: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      clock: "-"
    }
  },
  methods: {
  /* ToDashborad (){
    this.$router.push({ params: { language: "es", currentCompanyNifCif: "A20037552", currentModule:"fabric", currentDisplay:"machine",  targetEntity: '3d929bca-d9ba-4faf-ae15-27e89c0ce17a' } });
   },*/

    ToMachines (){
      this.$router.push({ params: { language: "es", currentCompanyNifCif: "A20037552", currentModule:"fabric", currentDisplay:"machines",  targetEntity: '' } });
      api.pointAtModule('electricalMonitoring');
    },

    ToProfile(){
      this.$router.push({ params: { currentModule:"general", currentDisplay:"profile",  targetEntity: '' } });
      api.pointAtModule('electricalMonitoring');
    },

    ToUsers(){
      this.$router.push({ params: { currentModule:"general", currentDisplay:"users",  targetEntity: '' } });
      api.pointAtModule('electricalMonitoring');
    },

    ToCharts(){
      this.$router.push({ params: { currentModule:"devices", currentDisplay:"charts",  targetEntity: '' } });
      api.pointAtModule('electricalMonitoring');
    },
    ToLogs(){
      this.$router.push({ params: { currentModule:"devices", currentDisplay:"Logs",  targetEntity: '' } });
      api.pointAtModule('electricalMonitoring');
    },
    ToDevices(){
      this.$router.push({ params: {  currentModule:"electricalMonitoring", currentDisplay:"devices",  targetEntity: '' } });
      api.pointAtModule('electricalMonitoring');
    },
    ToUtillajes(){
      this.$router.push({ params: {  currentModule:"electricalMonitoring", currentDisplay:"commandCenters",  targetEntity: '' } });
      api.pointAtModule('electricalMonitoring');
    },
    ToDash(){
      this.$router.push({ params: { currentModule:"electricalMonitoring", currentDisplay:"dashboardcomp",  targetEntity: '' } });
      api.pointAtModule('electricalMonitoring');
    },
    ToDevicesConf(){
      this.$router.push({ params: { language: "es", currentCompanyNifCif: "A20037552", currentModule:"electricalMonitoring", currentDisplay:"devicesconf",  targetEntity: '' } });
      api.pointAtModule('electricalMonitoring');
    },
    // NAVIGATE 
    onAvailableMenuItemClicked(page) {
      this.$emit('onAvailableMenuItemClicked');
      this.$router.replace({params: {currentDisplay: page.value, targetEntity: ""} })
    },
    // LOG OUT
    logOutRequest() {
      this.$emit('logOutRequest');
    },

    toggleDropdown(dropdown, menu, isOpen) {
      dropdown.classList.toggle("open", isOpen);
      menu.style.height = isOpen ? `${menu.scrollHeight}px` : 0;
    },
    togglemenu() {
      document.querySelectorAll(".dropdown-toggler").forEach(dropdownToggler => {
        dropdownToggler.addEventListener('click', e => {
          e.preventDefault();
          const sidebar = document.querySelector(".sidebar");
          const dropdown = e.target.closest(".dropdown-container");
          const menu = dropdown.querySelector(".dropdown-menu");
          const isOpen = dropdown.classList.contains("open");
          
          if (!sidebar.classList.contains("collapsed")) {
            this.toggleDropdown(dropdown, menu, !isOpen);
          }
        });
      });

      // Manejar el hover para cuando está colapsado
      const sidebar = document.querySelector(".sidebar");
      let hoverTimeout;
      
      document.querySelectorAll(".dropdown-container").forEach(dropdown => {
        const menu = dropdown.querySelector(".dropdown-menu");
        
        dropdown.addEventListener("mouseenter", () => {
          if (sidebar.classList.contains("collapsed")) {
            clearTimeout(hoverTimeout);
            this.toggleDropdown(dropdown, menu, true);
          }
        });
        
        dropdown.addEventListener("mouseleave", (e) => {
          if (sidebar.classList.contains("collapsed")) {
            // Verificar si el ratón está yendo al menú desplegado
            const relatedTarget = e.relatedTarget;
            if (!menu.contains(relatedTarget)) {
              hoverTimeout = setTimeout(() => {
                this.toggleDropdown(dropdown, menu, false);
              }, 300); // Pequeño retardo para permitir movimiento entre elementos
            }
          }
        });
        
        // Manejar el mouseleave del menú desplegado
        menu.addEventListener("mouseleave", (e) => {
          if (sidebar.classList.contains("collapsed")) {
            // Verificar si el ratón está yendo al dropdown
            const relatedTarget = e.relatedTarget;
            if (!dropdown.contains(relatedTarget)) {
              hoverTimeout = setTimeout(() => {
                this.toggleDropdown(dropdown, menu, false);
              }, 300);
            }
          }
        });
      });

      // Evita que los clicks en los enlaces del dropdown cierren el menú
      document.querySelectorAll(".dropdown-link").forEach(link => {
        link.addEventListener('click', e => {
          e.stopPropagation();
          // Cerrar el menú después de hacer clic (opcional)
          if (sidebar.classList.contains("collapsed")) {
            const dropdown = link.closest(".dropdown-container");
            const menu = dropdown.querySelector(".dropdown-menu");
            setTimeout(() => {
              this.toggleDropdown(dropdown, menu, false);
            }, 200);
          }
        });
      });
    },
    toggleSidebar() {
      const closeAllDropdowns = () => {
        document.querySelectorAll(".dropdown-container.open").forEach(openDropdown => {
          this.toggleDropdown(openDropdown, openDropdown.querySelector(".dropdown-menu"), false);
        });
      }
      const sidebar = document.querySelector(".sidebar");
      const sidebarToggler = document.querySelector('.togller'); 
      //collapsed state
      sidebarToggler.addEventListener('click', () => {
        closeAllDropdowns();
        sidebar.classList.toggle('collapsed');
      });
    },
    startClock() {
      setInterval(() => {
        this.clock = String(this.$dayjs(Date.now()).format('HH:mm:ss'));
      }, 1000)
    }
  },
  mounted() {
    this.toggleSidebar();
    this.togglemenu();
    this.startClock();
  }
}
 
</script>
 
<style>
 /* Añade esto al final de tu sección de estilos */
.sidebar.collapsed .dropdown-container {
  position: relative;
}

.sidebar.collapsed .dropdown-menu {
  display: none;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: auto;
}

.sidebar.collapsed .dropdown-container.open .dropdown-menu {
  display: block;
  opacity: 1;
}

.sidebar.collapsed .dropdown-container:hover .dropdown-menu,
.sidebar.collapsed .dropdown-menu:hover {
  display: block;
  opacity: 1;
}

.sidebar:not(.collapsed) .dropdown-container .dropdown-menu {
  pointer-events: auto;
}

/* Asegura que el menú no desaparezca durante la transición */
.sidebar.collapsed .dropdown-menu {
  pointer-events: none;
}

.sidebar.collapsed .dropdown-container.open .dropdown-menu,
.sidebar.collapsed .dropdown-container:hover .dropdown-menu,
.sidebar.collapsed .dropdown-menu:hover {
  pointer-events: auto;
}

  .mordazas{
    background-image: url("@/assets/img/mordazas.png");
 }
  .blocks{
    background-image: url("@/assets/img/blocks.png");
 }
  .mack{
    background-image: url("@/assets/img/0mack.png");
 }

  .logo{
    background-image: url("@/assets/img/logo-sm.png");
    width: 100px;
    height: 100px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
 }
 
 * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Mulish', sans-serif;
 }
 
 .icono{
    margin-left: -5px;
    width: 35px;
    height: 30px;
    filter: invert(1);
 }
 
 
  .sidebar{
    flex-direction: column;
    justify-content: flex-start;
    z-index: 999;
    width: 250px;
    position: fixed;
    margin-top: 7px;
    margin-left: 16px;
    /* border-radius: 16px;
    background: #01538f;
    background: linear-gradient(180deg, #01538f 0%, #0e739e 100%);*/
    background: #000;
    border-right: solid 1px #fff;
    height: calc(100vh - 12px);
    transition: 0.5s ease;
  }
 
  .sidebar-header .header-logo img{
    width: 100px;
    display: block;
    object-fit: contain;
    transition: 0.5s ease;
    border-radius: 50%;
  }
  .sidebar.collapsed{
    width: 70px;
    padding-left: 2px;
    padding-right: 2px;
  }
  .sidebar.collapsed .sidebar-nav .primary-nav{
    transform: translateY(65px);
    
  }
 
  .sidebar.collapsed .sidebar-nav .secondary-nav{
    transform: translateY(65px);
  }
 
  .sidebar.collapsed .sidebar-nav .nav-link :where(.nav-label, .dropdown-icon){
    transition: 0.2s ease;
  }

.sidebar.collapsed .sidebar-header .header-logo img{
    width: 70px;
    display: block;
    transition: 0.5s ease;
    object-fit: contain;
    margin-left: -30%;
    margin-bottom: 10%;
    border-radius: 50%;
}

.sidebar.collapsed .sidebar-nav .nav-link :where(.nav-label, .dropdown-icon){
    opacity: 0;
    pointer-events: none;

}

 .sidebar-header{
    position: relative;
    display: flex;
    padding: 25px 20px;
    align-items: center;
    justify-content: space-between;
 }

 
 .sidebar-header .togller{
    position: absolute;
    background: #1f2a3a;
    border: none;
    color: #fff;
    padding: 10px;
    border-radius: 8px;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
    right: 15px;
    height: 35px;
    width: 35px;
    transition: 0.5s ease;
 }
 
 .sidebar.collapsed .sidebar-header .togller{
   transform: translate(-10px, 40px);
    transition: 0.5s ease;
    justify-content: center;
    align-self: center;
 }
 
 .sidebar-header .togller:hover{
    background: #dde4fb;
    color: #1f2a3a;
 }
 
 .sidebar-header .togller:hover img{
    filter: invert(1);
 }
 
 .sidebar-header .togller img{
    font-size: 1.75rem;
    transition: 0.1s ease;
 
 }
 
 .sidebar.collapsed .sidebar-header .togller img{
    transform: rotate(180deg);
    transition: 0.1s ease;
 }
 
 .sidebar.collapsed .sidebar-nav .nav-list{
    list-style: none;
    padding: 0;
    gap: 4px;
    padding: 0 2px;
    flex-direction: column;
    transform: translateY(15px);
 
 }
 
 .sidebar-nav .nav-list{
    list-style: none;
    display: flex;
    gap: 5px;
    padding: 0 10px;
    flex-direction: column;
    transform: translateY(15px);
    transition: 0.4s ease;
 
 }
 
 .sidebar-nav .nav-link{
    color : #fff;
    text-decoration: none;
    padding: 12px 20px;
    gap: 12px;
    align-items: center;
    display: flex;
    border-radius: 8px;
    transition: 0.4s ease;
    margin-right: 1rem;
 }
 .sidebar-nav .nav-link:hover {
    background: #fff;
    color: #1f2a3a;
    transition: 0.4s ease;
 }
 
 .sidebar-nav .nav-link:hover img{
    filter: invert(1); /* Inverts the color to its opposite */
 }
 
 .sidebar-nav .nav-link:hover .icono {
    filter: invert(0);
    transition: 0.1ms ease;
 }
 
 .sidebar-nav .secondary-nav{
    position: absolute;
    bottom: 30px;
    width: 100%;
 }
 .secondary-nav .nav-item{
    position: relative;
    margin-right: 0.8rem;
 }
 
 .sidebar.collapsed .secondary-nav .nav-item{
    padding-right: 4px;
 }
 
 .sidebar-nav .secondary-nav .nav-tooltip{
    position: absolute;
    color: #1f2a3a;
    pointer-events: none;
    display: none;
    background: #fff;
    padding: 6px 12px;
    border-radius: 8px;
    top: -1px;
    left: calc(100% + 20px);
    opacity: 0;
    pointer-events: none;
    display: none;
    white-space: nowrap;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    transition: 0s ;
 }

 .sidebar-nav .primary-nav .nav-tooltip{
    position: absolute;
    color: #1f2a3a;
    background: #fff;
    pointer-events: none;
    display: none;
    padding: 6px 12px;
    border-radius: 8px;
    left: calc(100% + 20px);
    margin-top: -7px;
    opacity: 0;
    white-space: nowrap;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    transition: 0s ;
 }

 .sidebar.collapsed .sidebar-nav .nav-tooltip{
    display: block;
 }

 .sidebar-nav .nav-item:hover .nav-tooltip{
    opacity: 1;
    pointer-events: auto;
    transform: translateY(50%);
    transition: 0.4s ease;
 }

 
/* Dropdown */
.sidebar-nav .nav-item{
    position: relative;
}

.sidebar-nav .dropdown-container .dropdown-icon{
margin: 0 -4px 0 auto;
transition: transform 0.4s ease, opacity 0.3s 0.2s ease;
}

.sidebar.collapsed .dropdown-container .dropdown-icon{
    margin: 0 -4px 0 auto;
    transition: opacity 0.2s 0s ease;
}

.sidebar-nav .dropdown-container {
    position: relative;
}

.sidebar-nav .dropdown-menu{
    height: 0;
    overflow-y: hidden;
    list-style: none;
    padding-left: 15px;
    transition: height 0.4s ease;
}


.sidebar-nav .dropdown-menu{
  list-style: none;
  padding-left: 15px;
}

.sidebar-nav .dropdown-container.open .dropdown-icon{
transform: rotate(180deg);
}

.sidebar.collapsed .dropdown-menu {
    position: absolute;
    left: calc(100% + 5px);  
    opacity: 1;
    height: auto !important;
    max-height: 212px !important;
    overflow-y: unset;
    pointer-events: all;
    top: 0;
    background: #000;
    border-radius: 8px;
    width: 150px;
    margin-left: 0; 
    padding: 10px;
    transition: opacity 0.4s ease;
    z-index: 1000;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
    width: max-content;
}


.sidebar-nav .dropdown-link{
    color: #fff;
    text-decoration: none;
    display: block;
    padding: 10px 4px 10px 10px;
    transition: 0.4s ease;
    margin-top: 4px;
    width: 160px;
    
}

.dropdown-menu {
  border:none;
  margin-left: 20px;
  display: none;
  border-radius: 8px;
  background: black;
}
.dropdown-container.open .dropdown-menu {
  display: block;
}
 </style>